import React from "react";
import { Outlet } from "react-router-dom";

const SystemLog: React.FC = () => {
  return <Outlet />;
};

export default SystemLog;
